// extracted by mini-css-extract-plugin
export default {"containerAdmin":"aPanel_containerAdmin__4LLSR","formAdmin":"aPanel_formAdmin__bnLal","logOut":"aPanel_logOut__cw9YR","avalancheLevel":"aPanel_avalancheLevel__+Efg5"};